// ATL shared field validation — Name / Email dùng chung cho mọi form phía client.
// Phải khớp với inc/Helpers/FormFieldValidator.php (server là nơi chốt cuối cùng).
;(function (w) {
	'use strict';

	var MIN_NAME_LETTERS = 3;
	var MIN_RESTRICTED_LOCAL_LENGTH = 4;

	// / , ? ! ' " ‘ ’ “ ” @ & ; : < > { } [ ] % ^ * \ | ~ $ ¥ € •
	var FORBIDDEN_NAME_CHARS = /[\/,?!'"\u2018\u2019\u201C\u201D@&;:<>{}\[\]%^*\|~$¥€•]/;
	// Tên tổ chức được nới cho & , ' - .
	var FORBIDDEN_ORG_CHARS = /[\/?!"\u2018\u2019\u201C\u201D@;:<>{}\[\]%^*\|~$¥€•]/;

	var RESTRICTED_EMAIL_DOMAINS = /(^|\.)(gmail|googlemail|google|yahoo|ymail|rocketmail)\./i;
	var EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	var LETTER = /\p{L}/gu;

	function letters(value) {
		var found = value.match(LETTER);
		if (!found) {
			return [];
		}
		return found.map(function (char) {
			return char.toLowerCase();
		});
	}

	function distinctCount(list) {
		var seen = {};
		var total = 0;
		list.forEach(function (char) {
			if (!Object.prototype.hasOwnProperty.call(seen, char)) {
				seen[char] = true;
				total++;
			}
		});
		return total;
	}

	/**
	 * @returns {string|null} thông báo lỗi, hoặc null nếu hợp lệ.
	 * Chuỗi rỗng trả về null — required check của từng form tự lo.
	 */
	function nameError(name, label, isOrganisation) {
		var value = (name === null || name === undefined) ? '' : String(name).trim();
		label = label || 'Name';

		if (!value) {
			return null;
		}

		var forbidden = isOrganisation ? FORBIDDEN_ORG_CHARS : FORBIDDEN_NAME_CHARS;
		if (forbidden.test(value)) {
			return label + ' cannot contain special characters.';
		}

		var found = letters(value);

		if (found.length < MIN_NAME_LETTERS) {
			return label + ' must contain at least ' + MIN_NAME_LETTERS + ' letters.';
		}

		if (distinctCount(found) < 2) {
			return label + ' does not look like a real name.';
		}

		return null;
	}

	function emailError(email) {
		var value = (email === null || email === undefined) ? '' : String(email).trim();

		if (!value) {
			return null;
		}

		if (!EMAIL_FORMAT.test(value)) {
			return 'Please enter a valid email address.';
		}

		var at = value.lastIndexOf('@');
		var local = value.slice(0, at);
		var domain = value.slice(at + 1);

		if (RESTRICTED_EMAIL_DOMAINS.test(domain) && local.length < MIN_RESTRICTED_LOCAL_LENGTH) {
			return 'Gmail and Yahoo addresses must have at least ' + MIN_RESTRICTED_LOCAL_LENGTH + ' characters before the @.';
		}

		return null;
	}

	/**
	 * Gắn lỗi Name của một field vào object errors (nếu có).
	 */
	function checkNameField(form, fieldName, label, errors, isOrganisation) {
		var input = form ? form.querySelector('[name="' + fieldName + '"]') : null;
		if (!input || errors[fieldName]) {
			return;
		}
		var error = nameError(input.value, label, isOrganisation);
		if (error) {
			errors[fieldName] = error;
		}
	}

	/**
	 * Gắn lỗi Email của một field vào object errors (nếu có).
	 */
	function checkEmailField(form, fieldName, errors) {
		var input = form ? form.querySelector('[name="' + fieldName + '"]') : null;
		if (!input || errors[fieldName]) {
			return;
		}
		var error = emailError(input.value);
		if (error) {
			errors[fieldName] = error;
		}
	}

	w.ATLValidation = {
		nameError: nameError,
		emailError: emailError,
		isValidName: function (name, isOrganisation) {
			return nameError(name, null, isOrganisation) === null;
		},
		isValidEmail: function (email) {
			return emailError(email) === null;
		},
		checkNameField: checkNameField,
		checkEmailField: checkEmailField
	};
})(window);
